import { render, staticRenderFns } from "./GPathCareerUnivAdd.vue?vue&type=template&id=77f57619&scoped=true"
import script from "./GPathCareerUnivAdd.vue?vue&type=script&lang=js"
export * from "./GPathCareerUnivAdd.vue?vue&type=script&lang=js"
import style0 from "./GPathCareerUnivAdd.vue?vue&type=style&index=0&id=77f57619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f57619",
  null
  
)

export default component.exports